export interface UnitDataItem {
  id?: string;
  label: string;
  value: string;
  items: string[];
}
import { ReactComponent as CheckedSmall } from "assets/svg/checkedSmall.svg";
import { ReactComponent as PlaySmall } from "assets/svg/play.svg";
import { ReactComponent as PauseSmall } from "assets/svg/pause.svg";
import { ReactComponent as CloseSmall } from "assets/svg/closeSmall.svg";
import { ReactComponent as CircleSmall } from "assets/svg/circleSmall.svg";
import { ReactComponent as CompleteCircle } from "assets/svg/completeCircle.svg";
import { ReactComponent as InProgressCircle } from "assets/svg/inProgressCircle.svg";
import { ReactComponent as OnHoldOrange } from "assets/svg/onHoldOrange.svg";
import { ReactComponent as CancelCircle } from "assets/svg/cancelCircle.svg";
import { ReactComponent as TodoCircle } from "assets/svg/todoCircle.svg";

export const unitsData: UnitDataItem[] = [
  {
    label: "Weight",
    value: "weight",
    items: ["kg", "lbs"],
  },
  {
    label: "Height",
    value: "height",
    items: ["cm", "ft", "inches"],
  },
  {
    label: "Distance",
    value: "distance",
    items: ["km", "miles"],
  },
  {
    label: "Energy",
    value: "energy",
    items: ["kcal", "kj"],
  },
  {
    label: "Time",
    value: "time",
    items: ["minutes", "hours"],
  },
  {
    label: "Volume",
    value: "volume",
    items: ["cups", "fl oz", "ml"],
  },
  {
    label: "Count",
    value: "count",
    items: ["#"],
  },
  {
    label: "Scale",
    value: "scale",
    items: ["%"],
  },
  {
    label: "Currency",
    value: "currency",
    items: ["$", "£", "€"],
  },
];

export const actionItemFilterOptions = [
  {
    label: "Weight",
    value: "weight",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Progress",
    value: "progress",
  },
  {
    label: "Start Date",
    value: "startDate",
  },
  {
    label: "Due Date",
    value: "dueDate",
  },
  {
    label: "Weekly Duration",
    value: "weeklyDuration",
  },
  {
    label: "Assigned To",
    value: "assignedTo",
  },
];

export const actionItemWeightOptions = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },
  {
    label: "10",
    value: 10,
  },
];

export const ThresholdOptions = [
  {
    value: 1,
    label: "1 hr",
  },
  {
    value: 2,
    label: "2 hr",
  },
  {
    value: 3,
    label: "3 hr",
  },
  {
    value: 4,
    label: "4 hr",
  },
  {
    value: 5,
    label: "5 hr",
  },
  {
    value: 6,
    label: "6 hr",
  },
  {
    value: 7,
    label: "7 hr",
  },
  {
    value: 8,
    label: "8 hr",
  },
  {
    value: 9,
    label: "9 hr",
  },
  {
    value: 10,
    label: "10 hr",
  },
  {
    value: 11,
    label: "11 hr",
  },
  {
    value: 12,
    label: "12 hr",
  },
  {
    value: 13,
    label: "13 hr",
  },
  {
    value: 14,
    label: "14 hr",
  },
  {
    value: 15,
    label: "15 hr",
  },
  {
    value: 16,
    label: "16 hr",
  },
  {
    value: 17,
    label: "17 hr",
  },
  {
    value: 18,
    label: "18 hr",
  },
  {
    value: 19,
    label: "19 hr",
  },
  {
    value: 20,
    label: "20 hr",
  },
  {
    value: 21,
    label: "21 hr",
  },
  {
    value: 22,
    label: "22 hr",
  },
  {
    value: 23,
    label: "23 hr",
  },
  {
    value: 24,
    label: "24 hr",
  },
];

export const defaultColumns = [
  {
    id: 1,
    key: "action_items",
    title: "Action Items",
    isVisible: true,
    isFrozen: false,
    width: 500,
  },
  {
    id: 2,
    key: "weight",
    title: "Weight",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 3,
    key: "plan_progress",
    title: "Plan Progress",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 4,
    key: "status",
    title: "Status",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 5,
    key: "measurement",
    title: "Measurement",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 6,
    key: "start_date",
    title: "Start Date",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 7,
    key: "due_date",
    title: "Due Date",
    isVisible: true,
    isFrozen: false,
  },
  {
    id: 8,
    key: "duration",
    title: "Duration",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
  {
    id: 9,
    key: "assignee",
    title: "Assignee",
    isVisible: true,
    isFrozen: false,
    width: 150,
  },
];

export const statusOptions = [
  {
    label: "To Do",
    value: 1,
    color: "#94A3B8",
    icon: CircleSmall,
    circleIcon: TodoCircle,
  },
  {
    label: "In Progress",
    value: 2,
    color: "#32A6F9",
    icon: PlaySmall,
    circleIcon: InProgressCircle,
  },
  {
    label: "On Hold",
    value: 3,
    color: "#EAB308",
    icon: PauseSmall,
    circleIcon: OnHoldOrange,
  },
  {
    label: "Completed",
    value: 4,
    color: "#22C55E",
    icon: CheckedSmall,
    circleIcon: CompleteCircle,
  },
  {
    label: "Canceled",
    value: 5,
    color: "#EF4444",
    icon: CloseSmall,
    circleIcon: CancelCircle,
  },
];

export const categoryStatusOptions = [
  {
    label: "To Do",
    value: 1,
    color: "#94A3B8",
    icon: TodoCircle,
  },
  {
    label: "In Progress",
    value: 2,
    color: "#32A6F9",
    icon: InProgressCircle,
  },
  {
    label: "On Hold",
    value: 3,
    color: "#EAB308",
    icon: OnHoldOrange,
  },
  {
    label: "Completed",
    value: 4,
    color: "#22C55E",
    icon: CompleteCircle,
  },
  {
    label: "Canceled",
    value: 5,
    color: "#EF4444",
    icon: CancelCircle,
  },
];

export const priorityOptions = [
  {
    label: "Low",
    value: 1,
  },
  {
    label: "Medium",
    value: 2,
  },
  {
    label: "High",
    value: 3,
  },
];
